import YouTubeVideoPlayer from "@/components/VideoPlayer/components/YoutubeVideoPlayer";
import { CourseVideoDialogProps } from "./types";

import { Dialog, DialogContent, DialogTitle } from "@/components/Dialog";

const CourseVideoDialog = ({
  isOpen = false,
  close,
  videoUrl,
  title,
}: CourseVideoDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(isOpen) => !isOpen && close()}>
      <DialogContent
        className="border-0 bg-transparent"
        roundedCloseButton={true}
        aria-describedby={undefined}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <div className="min-h-[300px] h-[80vh]">
          <YouTubeVideoPlayer
            title={title}
            videoClassName="w-full h-full"
            videoUrl={videoUrl}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CourseVideoDialog;
